import Box from '../box'

Box.mdat = function () {
  delete this.subBox
}
